import Vue from 'vue';
import App from './App.vue';
import core from '@bmp-vue/core';
import hacktimer from 'hacktimer'
import ui from '@/api/ui.js'
import functions from '@/functions/index.js'
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";

Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);

Vue.config.productionTip = false;

var controllers = require.context('@/controllers', true, /\.js$/);
const theme = require('@/plugins/vuetify/theme').default;

let parceiros = JSON.parse(localStorage.getItem('parceiros')) || [];
let empresa = JSON.parse(localStorage.getItem('empresa')) || {};

let partner = null;

parceiros.forEach((parceiro) => {
  if (parceiro.value === empresa.codigo) {
    partner = parceiro;
  }
});

const paths = partner !== null
  ? require('@/plugins/router/paths').default(partner.onboardingContaHabilitado)
  : require('@/plugins/router/paths').default(false);

Vue.use(core, {
  controllers,
  paths,
  theme,
  defaultViews: false,
  carregaEnums: false,
  extendRouterBeforeEach: function (vm, to, from, next) {
    const empresa = vm.$store.getters.empresa
    const permite = empresa && empresa.codigo && empresa.codigo !== vm.global.GuidEmpty

    if (to.fullPath === '/authcompany' && permite) {
      return false
    }

    if (vm.$store._actions['default/beforeEach']) {
      vm.$store.dispatch('default/beforeEach', { to, from, next })
    }

    let partner = JSON.parse(localStorage.getItem('parceiros'));
    if (Array.isArray(partner))
      partner = partner.find(x => x.value == empresa.codigo);

    if (partner) {
      if (to.meta.allParametersRequired) {
        return to.meta.parameters.every(param => partner[param]);
      }
      if (to.meta.parameters) {
        return to.meta.parameters.some(param => partner[param]);
      }
    }

    return permite
  },
  mount: (options) => {
    require('@/components/')

    Vue.prototype.$api.UI = {
      ...Vue.prototype.$api.UI,
      ...ui
    }

    Vue.prototype.$api.Functions = {
      ...Vue.prototype.$api.Functions,
      ...functions
    }

    Vue.use(hacktimer)

        new Vue({
      ...options,
      render: h => h(App)
    }).$mount('#app');
  }
});
